
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const LeadersPage = lazy(() => import('../pages/leaders/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const GivePage = lazy(() => import('../pages/give/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/leaders',
    element: <LeadersPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/give',
    element: <GivePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
